module.exports = __webpack_public_path__ + "img/stylist.890d8ba1.png";